import { createContext } from 'react';

/** @typedef {'cutoff_1'|'cutoff_2'} CutOffPeriod */

export const BranchContext = createContext(/** @type {any} */ (null));

/**
 * Determines today's cut-off period: Cut-Off 1 (1st-15th) or Cut-Off 2 (16th-end).
 * @returns {CutOffPeriod}
 */
export function currentCutOffPeriod() {
  const day = new Date().getDate();
  return day <= 15 ? 'cutoff_1' : 'cutoff_2';
}
